<template>
  <!-- 模板部分保持不变 -->
  <div class="digital-countdown">
    <!-- 小时部分（可选） -->
    <div class="time-section" v-if="showHours">
      <div class="digit-box">{{ formattedHours[0] }}</div>
      <div class="digit-box">{{ formattedHours[1] }}</div>
      <div class="time-separator">:</div>
    </div>

    <!-- 分钟部分 -->
    <div class="time-section">
      <div class="digit-box">{{ formattedMinutes[0] }}</div>
      <div class="digit-box">{{ formattedMinutes[1] }}</div>
      <div class="time-separator">:</div>
    </div>

    <!-- 秒部分 -->
    <div class="time-section">
      <div class="digit-box">{{ formattedSeconds[0] }}</div>
      <div class="digit-box">{{ formattedSeconds[1] }}</div>
    </div>
  </div>
</template>

<script>
import {lotteryRecordTopOne} from "@/js/api/WebIndexApi";

export default {
  name: 'CountdownTimer',
  props: {
    // 原有props保持不变
    seconds: {
      type: Number,
      default: 60
    },
    showHours: {
      type: Boolean,
      default: false
    },
    autoStart: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      remainingTime: this.seconds,
      timer: null,
      isMounted: false
    }
  },
  computed: {
    // 原有computed保持不变
    formattedHours() {
      const hours = Math.floor(this.remainingTime / 3600)
      return hours.toString().padStart(2, '0').split('')
    },
    formattedMinutes() {
      const minutes = Math.floor((this.remainingTime % 3600) / 60)
      return minutes.toString().padStart(2, '0').split('')
    },
    formattedSeconds() {
      const seconds = this.remainingTime % 60
      return seconds.toString().padStart(2, '0').split('')
    }
  },
  mounted() {
    this.isMounted = true
    if (this.autoStart) {
      this.startTimer()
    }
  },
  beforeUnmount() {
    this.isMounted = false
    this.clearTimer()
  },
  created() {
    this.remainingTime = this.seconds
  },
  methods: {
    async startTimer() {
      this.clearTimer()
      this.timer = setInterval(async () => {
        if (!this.isMounted) {
          this.clearTimer()
          return
        }

        if (this.remainingTime > 0) {
          this.remainingTime--
        } else {
          this.clearTimer()

          // 触发time-up事件
          this.$emit('time-up')

          // 如果有提供fetchNewTime函数，则获取新时间
          var that = this;
          lotteryRecordTopOne({}, function (data) {
            console.log("定时器里获取时间",data)
            that.remainingTime = that.getSeconds(data.result.nextDateTime)
            console.log("时间到了获取新的时间",that.remainingTime)
            that.showTimer = true
            that.startTimer()
          })

        }
      }, 1000)
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    getSeconds(nextDateTimeStr) {
//       // 假设 data.result.nextDateTime 是一个有效的日期时间字符串，如 "2023-12-31T23:59:59"
//       const nextDateTime = new Date(nextDateTimeStr);
//       const now = new Date();
// // 计算时间差（毫秒）并转换为秒
//       const diffInSeconds = Math.floor((nextDateTime - now) / 1000);
// // 确保结果不为负数
//       const remainingSeconds = Math.max(0, diffInSeconds);
//       return remainingSeconds;

      // 处理 Safari 兼容性问题 - 替换空格为 T 并确保格式正确
      const safariCompatibleStr = nextDateTimeStr.replace(' ', 'T');

      // 创建日期对象（两种方式确保兼容性）
      let nextDateTime;
      if (typeof nextDateTimeStr === 'string') {
        // 方法1：直接解析（适用于大多数现代浏览器）
        nextDateTime = new Date(safariCompatibleStr);

        // 方法2：如果方法1返回无效日期，尝试手动解析
        if (isNaN(nextDateTime.getTime())) {
          const parts = nextDateTimeStr.split(/[- :]/);
          nextDateTime = new Date(parts[0], parts[1]-1, parts[2], parts[3], parts[4], parts[5]);
        }
      } else {
        // 如果传入的不是字符串，直接使用
        nextDateTime = new Date(nextDateTimeStr);
      }

      const now = new Date();

      // 计算时间差（毫秒）并转换为秒
      const diffInSeconds = Math.floor((nextDateTime - now) / 1000);

      // 确保结果不为负数
      return Math.max(0, diffInSeconds);


    },
    resetTimer(remainingTime) {
      this.seconds=remainingTime
      if (this.isMounted) {
        this.startTimer()
      }
    }
  }
}
</script>

<style scoped>
/* 原有样式保持不变 */
.digital-countdown {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  font-family: Arial, sans-serif;
}

.time-section {
  display: flex;
  align-items: center;
}

.digit-box {
  width: 40px;
  height: 60px;
  background-color: #fff;
  color: #000000;
  border-radius: 5px;
  border: 1px solid #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 28px;
  font-weight: bold;
  margin: 0 2px;
}

.time-separator {
  font-size: 28px;
  font-weight: bold;
  margin: 0 5px;
  color: #333;
}

@media (max-width: 768px) {
  .digit-box {
    width: 30px;
    height: 45px;
    font-size: 20px;
    border-radius: 4px;
    border: 1px solid #ccc;
  }

  .time-separator {
    font-size: 20px;
  }
}
</style>